import { Client, ClientType } from '../_models/Client.model';
import School from "../_resources/JsonData/ReportTypes/School.json";
import KinderGarden from "../_resources/JsonData/ReportTypes/KinderGarden.json";
import AirBNB from "../_resources/JsonData/ReportTypes/AirBnB.json";
import Commercial from "../_resources/JsonData/ReportTypes/Commercial.json";
import Domestic from "../_resources/JsonData/ReportTypes/Domestic.json";
import MCH from "../_resources/JsonData/ReportTypes/MCH.json";
import NDIS from "../_resources/JsonData/ReportTypes/NDIS.json";
import { useReportContext } from '../_context/ReportContext';
import { Report } from '../_models/Report.model';


export const useSetReportAndClient = () => {
  const { setNewReport } = useReportContext();

  const setReportAndClient = (client: Client) => {
    let newReportTemplate:Report;

    switch (client.Type) {
      case ClientType.School:
        newReportTemplate = School;
        break;
      case ClientType.Kindergarden:
        newReportTemplate = KinderGarden;
        break;
      case ClientType.AirBNB:
        newReportTemplate = AirBNB;
        break;
      case ClientType.Commercial:
        newReportTemplate = Commercial;
        break;
      case ClientType.Domestic:
        newReportTemplate = Domestic;
        break;
      case ClientType.MCH:
        newReportTemplate = MCH;
        break;
      case ClientType.NDIS:
        newReportTemplate = NDIS;
        break;
      default:
        newReportTemplate = Commercial; // or another default template
    }

    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${String(
      currentDate.getMonth() + 1
    ).padStart(2, "0")}-${String(currentDate.getDate()).padStart(2, "0")}`;

    setNewReport((report) => ({
      ...report,
      ...newReportTemplate,
      ReportedDate: formattedDate,
      Client: client
    }));
  };

  return setReportAndClient;
};
